import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineUploadFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#999"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.625}
      d="M17.219 17.219a1.313 1.313 0 0 1-1.313 1.312H4.094A1.313 1.313 0 0 1 2.78 17.22V2.78A1.313 1.313 0 0 1 4.094 1.47h8.531l4.594 4.594z"
    />
    <path
      stroke="#999"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.625}
      d="M12.625 9.344 10 6.719 7.375 9.344M10 6.719v7.219"
    />
  </svg>
);
export default SvgStreamlineUploadFile;
